import { useReducer, useEffect } from "react";
import logListReducer, { initialState } from "./reducer";
import { fetchLogList } from "./api";
import ACTIONS from "./actions";

function useLogListReducer(chargerId) {
  const [state, dispatch] = useReducer(logListReducer, initialState);

  useEffect(() => {
    if (!chargerId) return;

    const abortController = new AbortController();

    async function fetchData() {
      dispatch({ type: ACTIONS.FETCH_LOG_LIST_INIT });
      try {
        // Extract serialNumber if chargerId contains refresh trigger (format: serialNumber_refreshTrigger)
        let actualChargerId = chargerId;
        if (typeof chargerId === "string") {
          const match = chargerId.match(/^(.+)_(\d+)$/);
          if (match && match[2]) {
            actualChargerId = match[1];
          }
        }
        const logListData = await fetchLogList(actualChargerId, { signal: abortController.signal });
        if (logListData) {
          dispatch({ type: ACTIONS.FETCH_LOG_LIST_SUCCESS, payload: logListData?.data });
        } else {
          dispatch({ type: ACTIONS.FETCH_LOG_LIST_FAILURE });
        }
      } catch (error) {
        if (error?.name === "CanceledError" || abortController.signal.aborted) return;
        dispatch({ type: ACTIONS.FETCH_LOG_LIST_FAILURE });
      }
    }

    fetchData();
    return () => {
      abortController.abort();
    };
  }, [chargerId]);

  return {
    state,
  };
}

export default useLogListReducer;
